import React from 'react';
import { Box, Text, TextArea } from '@rsos/base-components';

interface FieldNotesProps {
  value: string;
  onChange: React.ChangeEventHandler<HTMLTextAreaElement>;
}

const FieldNotes = ({ value, onChange }: FieldNotesProps) => {
  return (
    <Box data-name="share-event-field-notes">
      <Text color="secondaryText" size="normal" mb="8px">
        Send a message (optional)
      </Text>
      <TextArea
        value={value}
        onChange={onChange}
        id="field-notes"
        placeholder="Additional comments"
        height="130px"
        padding="16px"
        fontSize="14px"
        maxLength={280}
      />
      <Box mt="4px">
        <Text color="secondaryText" size="small">
          {value.length}/280 characters
        </Text>
      </Box>
    </Box>
  );
};

export default FieldNotes;
